export default __webpack_public_path__ + "static/media/coding.65744abc.jpg";